import { DestroyRef, Injectable, inject } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';

// Время прелоада по умолчанию
export const DEFAULT_PRELOAD_DELAY_MS: number = 10000; // 10 секунд
// Время прелоада для Чекаута
export const ORDERING_PRELOAD_DELAY_MS: number = 30000; // 30 секунд

@Injectable({
  providedIn: 'root',
})
export class DelayedPreloadStrategy implements PreloadingStrategy {
  private platformService: PlatformService = inject(PlatformService);
  private destroyRef: DestroyRef = inject(DestroyRef);

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    // Проверяем, есть клиент и флаг preload в data роута
    if (this.platformService.isBrowser && route.data && route.data['preload'] === true) {
      // Получаем время задержки из data роута или используем значение по умолчанию
      const delayMs: number = route.data['preloadDelay'] || DEFAULT_PRELOAD_DELAY_MS;

      // Задержка перед прелоадом
      return timer(delayMs).pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef),
        switchMap(() => load())
      );
    }

    // Если сервер или флаг preload не установлен, не прелоадим
    return of(null);
  }
}
